import { useEffect } from 'react'

export const useSendEventOnLoad = ({ event }: { event: () => void }) => {
  useEffect(() => {
    if (typeof event === 'function') {
      setTimeout(() => {
        // Run with delay so it runs after everything else
        event()
      }, 200)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
